import React from 'react';
import {useHistory} from 'react-router-dom';
import Header from './components/Header';
import LandingPage from './components/pages/LandingPage';
import SurveyPage from './components/pages/SurveyPage';
import SummaryPage from './components/pages/SummaryPage';
import Footer from './components/Footer';
import classnames from 'classnames';
import {GuideAppContainer, RenderOnlyFor, useNeuroState, usePages, PageContainer, useGuideConfig, Timeout} from "@ignitesales/neuro-application";
import queryString from 'query-string';

const AppBase = () => {
  const urlQuery = window.location.search;
  const parsed = queryString.parse(urlQuery);
  const skipLandingPage = parsed.quickStart !== undefined;
  const { isLoadingNextPage, isAnimatingPages } = usePages();
  const { user } = useNeuroState();
  const { isBranchGuide } = useGuideConfig();
  const history = useHistory();
  const bemClass = 'pageContainer';
  const contentClasses = classnames({
    [`${bemClass}__branch`]: isBranchGuide,
    [`${bemClass}__online`]: !isBranchGuide,
  });

  const onIdleTimeout = () => {
    history.push('/guide');
    history.go('/guide');
  };

  return <>
    <Timeout timeout={600000} onIdle={onIdleTimeout} />
    <GuideAppContainer>
      <Header processingNavigation={isLoadingNextPage || isAnimatingPages} />
      <PageContainer
        LandingPage={LandingPage}
        SurveyPage={SurveyPage}
        SummaryPage={SummaryPage}
        DetailsPage={SummaryPage}
        className={contentClasses}
      />
      <RenderOnlyFor forLandingPage={!skipLandingPage} forSummaryPage={true} forDetailsPage={true}>
        <Footer user={user} />
      </RenderOnlyFor>
    </GuideAppContainer>
  </>;
};

export default AppBase;
